import React from 'react';

const Merch = (props) => {
    return (
        <h1>
            Merch page
        </h1>
    )
}

export default Merch;